import { gql } from 'graphql-request'

const GET_APPLICATION = gql`
  query application($id: ID!) {
    application(id: $id) {
      bundleId
      clientSecurityToken
      sdkSecurityToken
      createdAt
      id
      name
      platform
      rankingSourceAppId
      rewardCallbackToken
      rewardCallbackUrl
      status
      storeInfo
      notInStore
      storeUrl
      apiFeedEnabled
      apiFeedKey
      updatedAt
    }
  }
`

export default GET_APPLICATION
